export const LOADING_JOURNALENTRY = "LOADING_JOURNALENTRY";
export const GET_JOURNALENTRY_LIST = "GET_JOURNALENTRY_LIST";
export const ADD_JOURNALENTRY = "ADD_JOURNALENTRY";
export const REMOVE_JOURNALENTRY = "REMOVE_JOURNALENTRY";
export const UPDATE_JOURNALENTRY = "UPDATE_JOURNALENTRY";
export const GET_JOURNALENTRY_ID = "GET_JOURNALENTRY_ID";